import script from "./MenuFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuFilters.vue?vue&type=script&setup=true&lang=ts"

import "./MenuFilters.vue?vue&type=style&index=0&id=2661a9eb&lang=scss"

const __exports__ = script;

export default __exports__